var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendInput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1542 2.55279C10.9848 2.214 10.6385 2 10.2598 2C9.881 2 9.53474 2.214 9.36535 2.55279L2.36535 16.5528C2.188 16.9075 2.23701 17.3335 2.49027 17.6386C2.74353 17.9438 3.15319 18.0705 3.5345 17.9615L8.53449 16.533C8.96379 16.4103 9.25977 16.0179 9.25977 15.5714V11C9.25977 10.4477 9.70748 10 10.2598 10C10.8121 10 11.2598 10.4477 11.2598 11V15.5714C11.2598 16.0179 11.5557 16.4103 11.985 16.533L16.9851 17.9615C17.3664 18.0705 17.776 17.9438 18.0293 17.6386C18.2825 17.3335 18.3316 16.9075 18.1542 16.5528L11.1542 2.55279Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendInput);
export default __webpack_public_path__ + "static/media/send-input.6360da10b405b5c6215743bedd2e344f.svg";
export { ForwardRef as ReactComponent };